/**
 * Common SPDX license identifiers
 * @see https://spdx.org/licenses/
 */
export const COMMON_LICENSES = [
	"MIT",
	"Apache-2.0",
	"GPL-3.0",
	"GPL-2.0",
	"LGPL-3.0",
	"BSD-3-Clause",
	"BSD-2-Clause",
	"ISC",
	"MPL-2.0",
	"UNLICENSED",
];

/**
 * OSI-approved open source licenses
 * @see https://opensource.org/licenses
 */
export const OSI_APPROVED_LICENSES = [
	"MIT",
	"Apache-2.0",
	"GPL-3.0",
	"GPL-2.0",
	"LGPL-3.0",
	"LGPL-2.1",
	"BSD-3-Clause",
	"BSD-2-Clause",
	"ISC",
	"MPL-2.0",
	"AGPL-3.0",
	"EPL-2.0",
	"CC0-1.0",
];
